import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LandingContainer } from "./LandingContainer";

export default function Landing() {
  const navigate = useNavigate();
  return <LandingContainer />;
}
